import { Component, Input, Output, EventEmitter, OnChanges } from '@angular/core';

export interface BenefitClick {
  modal?: any;
  page?: string;
}

export interface BenefitLink {
  title: string;
  url?: string;
  modal?: string;
}

export interface BenefitData {
  rows: number;
  cols: number;
  img: string;
  icon: string;
  title: string;
  subtitle: string;
  descriptionActionButton: string;
  modal?: any;
  page?: string;
}

export interface BenefitsData {
  title: string;
  subtitle: string;
  links?: Array<BenefitLink>
  data: Array<BenefitData>;
}

@Component({
  selector: 'fcp-showcase-benefits',
  templateUrl: './showcase-benefits.component.html',
  styleUrls: ['./showcase-benefits.component.scss']
})
export class ShowcaseBenefitsComponent implements OnChanges {

  @Input() public benefits: BenefitsData = null;
  @Output() public wasClicked: EventEmitter<any> = new EventEmitter();
  @Output() public wasClickedPage: EventEmitter<any> = new EventEmitter();

  public isVertical = false;

  public emitClick(benefit: BenefitClick): void {
    if (benefit.modal) {
      this.wasClicked.emit(benefit.modal);
    } else if (benefit.page) {
      this.wasClickedPage.emit(benefit.page);
    } else {
      this.wasClicked.emit(benefit);
    }
  }

  public ngOnChanges(): void {
    if (this.benefits) {
      const hasMoreThanOneRow = this.benefits.data.some((benefit: BenefitData) => benefit.rows > 1);
      this.isVertical = hasMoreThanOneRow && this.benefits.data.length > 4;
    }
  }

}
